import { useIdentityStore } from '~/store/identity'
import { useRootStore } from '~/store/root'

export default defineNuxtPlugin(async () => {
  if (useRoute().path === '/healthcheck' || useRoute().path.startsWith('/_nuxt')) {
    return
  }

  const identityStore = useIdentityStore()
  await identityStore.getSupportedIdentityProvidersForClient()
  const ssoFailed = useRoute().query?.ssoFailed
  const isSsoLogin = useRoute().path.startsWith(identityStore.ssoLoginUrl)

  if (!isSsoLogin && !ssoFailed && !useRootStore().isLoggedIn && identityStore.onlySsoSupported) {
    await identityStore.initiateSamlSsoLogin()
  }
})
